import React from 'react'

const Menu = () => {
  return (
    <div>
        <h1 className="font-Bree text-white text-6xl">Menu</h1>
         
          <h2 className="text-1xl pt-2">
            <span className="font-Bree text-green-600 ">Vegetarian</span>
            <span className="font-Bree text-white px-2">/</span>
            <span className="font-Bree text-red-600 ">Non-Vegetarian</span>
        </h2> 
    
    </div>
  )
}

export default Menu